import { render, staticRenderFns } from "./Receive.vue?vue&type=template&id=3b88ed1c&scoped=true&"
import script from "./Receive.vue?vue&type=script&lang=js&"
export * from "./Receive.vue?vue&type=script&lang=js&"
import style0 from "./Receive.vue?vue&type=style&index=0&id=3b88ed1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b88ed1c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data-jenkins/jenkins/workspace/html-cube-webapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b88ed1c')) {
      api.createRecord('3b88ed1c', component.options)
    } else {
      api.reload('3b88ed1c', component.options)
    }
    module.hot.accept("./Receive.vue?vue&type=template&id=3b88ed1c&scoped=true&", function () {
      api.rerender('3b88ed1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DesignEditor/component/panel/Receive.vue"
export default component.exports